export default "__VITE_ASSET__CaRPbW9A__"